import { FlexRow } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import { getGoalName } from '@common/financialEntities';
import { Goal } from '@common/goals';
import { FlexCol } from '../common/Flex';
import { Text } from '../common/Typography';
import GoalIcon, { GoalIconProps } from './GoalIcon';

interface GoalLockupProps extends FlexProps {
    goal: Goal;
    withPlentyPrefix?: boolean;
    maxW?: FlexProps['maxW'];
    iconProps?: Omit<GoalIconProps, 'goal'>;
}

export default function GoalLockup({
    goal,
    withPlentyPrefix,
    maxW = 48,
    iconProps,
    ...props
}: GoalLockupProps) {
    return (
        <>
            <FlexRow {...props}>
                <GoalIcon mr={4} goal={goal} {...iconProps} />
                <FlexCol justifyContent="center" maxW={maxW}>
                    <Text
                        overflow="hidden"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                    >
                        {getGoalName(goal, { withPlentyPrefix })}
                    </Text>
                </FlexCol>
            </FlexRow>
        </>
    );
}
